import { format, parseISO, isValid } from "date-fns";
import { pl } from "date-fns/locale";

/**
 * Formats a date string or Date object to Polish locale format (e.g., "5 sty 2025")
 * Returns "-" for null/undefined or invalid dates
 */
export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) return "-";
  try {
    const dateObj = typeof date === "string" ? parseISO(date) : date;
    if (!isValid(dateObj)) return "-";
    return format(dateObj, "d MMM yyyy", { locale: pl });
  } catch {
    return "-";
  }
};

/**
 * Formats a date range with two dates in Polish locale format
 * Returns formatted string like "1 sty 2024 - 31 gru 2024"
 */
export const formatDateRange = (
  start: string | Date | null | undefined,
  end: string | Date | null | undefined
): string => {
  return `${formatDate(start)} - ${formatDate(end)}`;
};
